import { useEffect, useRef } from 'react';
import { useLocation, useNavigationType } from 'react-router-dom';

/**
 * Resets the Pro shell's shared IonContent scroll position on forward
 * navigation. Skips POP (Back/Forward) so list pages keep their scroll
 * position when returning from a detail screen.
 */
export function useProScrollReset() {
  const { pathname } = useLocation();
  const navigationType = useNavigationType();
  const contentRef = useRef<HTMLIonContentElement>(null);

  useEffect(() => {
    if (navigationType === 'POP') return;
    void contentRef.current?.scrollToTop(0);
  }, [pathname, navigationType]);

  return contentRef;
}
